import React from "react";
import styled from "styled-components";
import metadata from "../../src/metadata.json"

const DashboardContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 80vh;
    padding: 20px;
    background-color: #f9f9f9;
`;

const Header = styled.header`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const Title = styled.h1`
    font-size: 2.5rem;
    color: #333;
    margin-top: 20px;
    font-weight:600
`;

const Main = styled.main`
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
`;

const Description = styled.p`
    font-size: 1.2rem;
    color: #666;
`;

export const Dashboard = () => {

    const userName = localStorage.getItem("userName") || "";
    const displayName = userName
  .split(".")[0]
  .replace(/^./, (c) => c.toUpperCase());

    return (
        <DashboardContainer>
            <Header>
                {/* <Logo src={LogoImg} alt="ZBIZ logo" /> */}
              <Title>Good Morning, {displayName || "User"}!</Title>
                {/* <SubTitle>Welcome to ZBIZ Banking System</SubTitle> */}
            </Header>

            <Main>
                <h3 style={{ "fontWeight": 500 }}>Welcome to ZBIZ Banking System</h3>
                <Description>At ZBIZ, we aim to provide the most reliable, comprehensive, and user-friendly banking experience. With our cutting-edge digital banking system, manage your finances at your fingertips.</Description>
                <div style={{ fontSize: "12px", fontWeight: "500" }}>
                    {`Version ${metadata.buildMajor}.${metadata.buildMinor}.${metadata.buildRevision}`}
                </div>
            </Main>
        </DashboardContainer>
    );
};
